import React, { Component } from "react";
import classnames from "classnames";

import * as styles from "./Page.scss";

export interface IPageProps {
    index: number;
    activeIndex: number;
    children?: React.ReactNode;
}

export class Page extends Component<IPageProps> {
    public render() {
        const { index, activeIndex } = this.props;
        const hidden = index !== activeIndex;
        return (
            <div className={classnames(styles.page, hidden && styles.hidden)}>
                {this.props.children}
            </div>
        );
    }
}
